import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelectorProps } from './useSelectorProps';
import { useSeoMeta } from './useSeoMeta';
export var useWebPageSchema = function useWebPageSchema() {
  var mainEntity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var metaTitleOtherPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var pageDescriptionOtherPage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var _useIntl = useIntl(),
      locale = _useIntl.locale,
      formatMessage = _useIntl.formatMessage;

  var _useSelectorProps = useSelectorProps(),
      pathname = _useSelectorProps.location.pathname;

  var _useSeoMeta = useSeoMeta(),
      pageTitle = _useSeoMeta.pageTitle,
      metaDescription = _useSeoMeta.metaDescription,
      metaTitle = _useSeoMeta.metaTitle,
      pageDescription = _useSeoMeta.pageDescription;

  return useMemo(function () {
    return JSON.stringify({
      '@context': 'http://schema.org',
      '@type': 'WebPage',
      name: metaTitleOtherPage || metaTitle,
      dateModified: new Date().toISOString(),
      description: pageDescriptionOtherPage || metaDescription,
      publisher: {
        '@type': 'Organization',
        name: 'Minfin.com.ua',
        knowsLanguage: ['uk-UA', 'ru-UA'],
        description: formatMessage({
          id: 'pageSchema.publisher.description'
        }),
        url: "".concat(process.env.APP_MINFIN_DOMAIN, "/"),
        logo: {
          '@type': 'ImageObject',
          url: "".concat(process.env.APP_MINFIN_DOMAIN, "/i/redesign/minfin-logo-ru.png")
        },
        foundingDate: '2008',
        sameAs: ['https://www.facebook.com/minfin.com.ua/', 'https://t.me/Minfin_com_ua/', 'https://www.youtube.com/channel/UCEW1QlFX_ito4gd3QXxyt5Q/', 'https://twitter.com/MinfinComUa/', 'https://www.instagram.com/minfin.com.ua/'],
        address: {
          '@type': 'PostalAddress',
          addressCountry: {
            '@type': 'Country',
            name: formatMessage({
              id: 'pageSchema.addressCountry.name'
            })
          },
          addressLocality: formatMessage({
            id: 'pageSchema.addressLocality'
          }),
          postalCode: '03038',
          streetAddress: formatMessage({
            id: 'pageSchema.streetAddress'
          })
        },
        contactPoint: [{
          '@type': 'ContactPoint',
          telephone: '+38(044)392-47-40',
          contactType: 'customer service',
          areaServed: 'UA',
          availableLanguage: ['Ukrainian', 'Russian'],
          email: 'info@minfin.com.ua'
        }]
      },
      mainEntity: mainEntity
    });
  }, [metaDescription, pageDescription, metaTitle, pageTitle, locale, pathname, pageDescriptionOtherPage, metaTitleOtherPage, mainEntity]);
};
export default useWebPageSchema;